// extracted by css-extract-rspack-plugin
export default {"content":"ResolvedPromptDisplay-module__content__DLWLK"};